import {
  type DeleteApiJingleCollectionsIdPathParams,
  type PostApiJingleCollectionsMutationRequest,
  type PutApiJingleCollectionsIdMutationRequest,
  type PutApiJingleCollectionsIdPathParams,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import {
  jingleCollectionByIdQuery,
  jingleCollectionCreate,
  jingleCollectionDelete,
  jingleCollectionUpdate,
} from '../api'

// By Id
interface JingleCollectionGateProps {
  id: string
}
export const JingleCollectionGate = createGate<JingleCollectionGateProps>()

sample({
  clock: JingleCollectionGate.open,
  fn: ({ id }: JingleCollectionGateProps) => ({ id }),
  target: jingleCollectionByIdQuery.start,
})

sample({
  clock: JingleCollectionGate.close,
  target: jingleCollectionByIdQuery.reset,
})

// Create

export const jingleCollectionSubmitted =
  createEvent<PostApiJingleCollectionsMutationRequest>()
sample({
  clock: jingleCollectionSubmitted,
  fn: (data) => ({ data }),
  target: [jingleCollectionCreate.start],
})

sample({
  clock: jingleCollectionCreate.finished.success,
  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

// Edit

export const jingleCollectionEdited = createEvent<{
  id: PutApiJingleCollectionsIdPathParams['Id']
  data: PutApiJingleCollectionsIdMutationRequest
}>()
sample({
  clock: jingleCollectionEdited,
  fn: ({ id, data }) => ({ id, data }),
  target: [jingleCollectionUpdate.start],
})

sample({
  clock: jingleCollectionUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})
// Delete

export const jingleCollectionDeleted = createEvent<{
  id: DeleteApiJingleCollectionsIdPathParams['Id']
}>()

sample({
  clock: jingleCollectionDeleted,
  fn: ({ id }) => ({ id }),
  target: [jingleCollectionDelete.start],
})

sample({
  clock: jingleCollectionDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})
